export const GoldDivider = ({ className = "" }) => (
  <div className={`gold-divider ${className}`} aria-hidden="true" />
);
